var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { globalTracer } from 'opentracing';
class Section {
    constructor(span) {
        this.children = [];
        this._span = span;
    }
    tag(name, value) {
        this._span.setTag(name, value);
        return this;
    }
    child(name) {
        const tracer = globalTracer();
        const span = tracer.startSpan(name, { childOf: this._span });
        const section = new Section(span);
        this.children.push(section);
        return section;
    }
    span() {
        return this._span;
    }
    section(name, cb) {
        return __awaiter(this, void 0, void 0, function* () {
            const section = this.child(name);
            try {
                return yield cb();
            }
            finally {
                section.finish();
            }
        });
    }
    finish() {
        this.children.forEach(child => child.finish());
        this._span.finish();
    }
    info(message, payload) {
        if (payload === undefined) {
            this._span.log({ message });
        }
        else {
            this._span.log({ message, payload });
        }
        return this;
    }
    error(err) {
        this._span.setTag('error', true);
        if (typeof err === 'string') {
            this._span.log({
                event: 'error',
                'error.message': err,
            });
        }
        else {
            this._span.log({
                event: 'error thrown',
                error: Object.assign({ message: err.message }, err),
            });
        }
        return this;
    }
    payload(payload) {
        this._span.log(payload);
    }
}
export default Section;
//# sourceMappingURL=Section.js.map